import { EMPTY_OBJECT } from '@/redux/selectors/pieveSelectors/constants.js';

const getComposerSelectorOptionsObject = (options) => {
  return options && typeof options === 'object' && !Array.isArray(options) ? options : EMPTY_OBJECT;
};

export default getComposerSelectorOptionsObject;
